import { ButtonLink } from '@spark-web/button';
import { ContentDialog } from '@spark-web/modal-dialog';
import { Text } from '@spark-web/text';
import { TextLink } from '@spark-web/text-link';
import { TextList } from '@spark-web/text-list';

const MYGOV_URL = 'https://my.gov.au/';

function NoaHelpModal({ isOpen, onToggle }: { isOpen: boolean; onToggle: () => void }) {
  return (
    <ContentDialog
      title="Finding your Notice of Assessment"
      isOpen={isOpen}
      onToggle={onToggle}
      size="small"
      css={{ '& header': { paddingTop: 24 } }}
      footer={
        <ButtonLink href={MYGOV_URL} target="_blank" rel="noopener noreferrer">
          Go to myGov
        </ButtonLink>
      }
    >
      <TextList type="number" size="large" gap="medium">
        <Text>
          Sign in to{' '}
          <TextLink href={MYGOV_URL} tone="primaryActive" target="_blank" rel="noopener noreferrer">
            myGov
          </TextLink>{' '}
          and select the Australian Taxation Office link.
        </Text>
        <Text>
          Go to the menu and navigate to:{' '}
          <Text as="span" inline weight="semibold">
            Tax &gt; Lodgments &gt; Income tax
          </Text>
        </Text>
        <Text>
          Select the{' '}
          <Text as="span" inline weight="semibold">
            History
          </Text>{' '}
          tab.
        </Text>
        <Text>
          Click the{' '}
          <Text as="span" inline weight="semibold">
            Notice of Assessment
          </Text>{' '}
          link for the relevant financial year to download and save a PDF.
        </Text>
      </TextList>
    </ContentDialog>
  );
}

export default NoaHelpModal;
